import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalProgress = ({ goals }) => {
  const getProgressColor = (percentage) => {
    if (percentage >= 100) return 'var(--color-success)';
    if (percentage >= 75) return 'var(--color-primary)';
    if (percentage >= 50) return 'var(--color-accent)';
    return 'var(--color-warning)';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading">
          Progreso de Metas
        </h3>
        <Icon name="Target" size={24} color="var(--color-primary)" />
      </div>
      <div className="space-y-6">
        {goals?.map((goal) => (
          <div key={goal?.id} className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <Icon 
                  name={goal?.icon} 
                  size={20} 
                  color={getProgressColor(goal?.progress)}
                />
                <div>
                  <p className="text-sm font-medium text-foreground">
                    {goal?.title}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {goal?.current} / {goal?.target} {goal?.unit}
                  </p>
                </div>
              </div>
              <span 
                className="text-sm font-semibold data-text"
                style={{ color: getProgressColor(goal?.progress) }}
              >
                {goal?.progress}%
              </span>
            </div>

            <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
              <div 
                className="h-full rounded-full transition-smooth"
                style={{ 
                  width: `${Math.min(goal?.progress, 100)}%`,
                  backgroundColor: getProgressColor(goal?.progress)
                }}
              />
            </div>

            {goal?.progress >= 100 && (
              <div className="flex items-center space-x-2 text-success">
                <Icon name="CheckCircle2" size={16} />
                <span className="text-xs font-medium">
                  ¡Meta completada!
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoalProgress;